import { hbs } from 'ember-cli-htmlbars';
export default hbs("<NwReportsPage @dynamicView={{this.model}} />")